<div class="w-full bg-light min-h-screen flex flex-col">
  <app-header-home
    class="w-full"
    [typeJobs]="jobTypes"
    [locations]="province"
    (filtersChanged)="onFiltersChanged($event, default_page)"
  >
  </app-header-home>
  <main
    class="flex flex-col md:flex-row gap-4 p-4 w-full"
    style="min-height: calc(100vh - 64px)"
  >
    <section
      class="w-full md:w-1/3 bg-white flex flex-col rounded-sm px-4 pt-4 md:sticky md:top-5 self-start"
    >
      <div>
        <div class="flex justify-between items-center mb-4">
          <h2 class="text-lg font-semibold">Ofertas de empleo</h2>
        </div>
        <div *ngIf="isLoadingJobs" class="animate-pulse flex flex-col gap-3">
          <div
            *ngFor="let _ of [1, 2, 3, 4]"
            class="flex items-center gap-3 p-3 rounded-lg bg-gray-100"
          >
            <div class="w-10 h-10 bg-gray-300 rounded"></div>
            <div class="flex flex-col gap-1 flex-1">
              <div class="w-3/4 h-4 bg-gray-300 rounded"></div>
              <div class="w-2/3 h-3 bg-gray-200 rounded"></div>
              <div class="w-1/2 h-2 bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>
        @if(!isLoadingJobs){
        <div *ngIf="jobs.length > 0; else noJobs">
          <div
            *ngFor="let job of jobs"
            (click)="selectJob(job)"
            class="flex items-center gap-3 p-3 rounded-lg cursor-pointer transition"
            [ngClass]="{
              'bg-primary text-white':
                selectedJob?.idJobOffer === job.idJobOffer,
              'hover:bg-gray-50': selectedJob?.idJobOffer !== job.idJobOffer
            }"
          >
            <img
              [src]="companyImageFor(job)"
              class="w-10 h-10 rounded object-cover shadow-lg flex-shrink-0"
              alt="Company Logo"
            />
            <div class="flex flex-col w-0 flex-1 min-w-0">
              <h3
                class="font-semibold flex items-center gap-2 text-sm sm:text-base break-words"
              >
                <span class="truncate">{{ job.title }}</span>
                <span
                  *ngIf="job.publicationStatus === 'Finalizado'"
                  class="text-xs italic text-red-500 border border-red-300 bg-red-50 px-2 py-0.5 rounded-full whitespace-nowrap"
                >
                  Finalizado
                </span>
              </h3>
              <p
                class="text-sm leading-tight"
                [ngClass]="
                  selectedJob?.idJobOffer === job.idJobOffer
                    ? 'text-white/90'
                    : 'text-gray-500'
                "
              >
                {{ job.companyName }} • {{ job.area }}
              </p>
              <p
                class="text-xs"
                [ngClass]="
                  selectedJob?.idJobOffer === job.idJobOffer
                    ? 'text-white/70'
                    : 'text-gray-400'
                "
              >
                Publicado {{ job.publicationDate | timeAgo }}
              </p>
            </div>
          </div>
        </div>
        <ng-template #noJobs>
          <div
            class="w-full flex items-center justify-center py-10 text-gray-500"
          >
            <p class="text-lg font-medium text-center">
              No hay resultados de ofertas de empleo
            </p>
          </div>
        </ng-template>
        }
      </div>
      @if(!isLoadingJobs){
      <div
        class="flex flex-col sm:flex-row items-center justify-between mt-5 mb-5 gap-3 text-center sm:text-left"
      >
        <div
          class="text-xs sm:text-sm text-gray-600 hidden sm:block lg:block md:hidden"
        >
          Mostrando {{ showingFrom }} - {{ showingTo }} de
          {{ pagination.total }}
        </div>
        <div
          class="flex items-center space-x-1 sm:space-x-2 flex-wrap justify-center w-full sm:w-auto"
        >
          <button
            (click)="prevPage()"
            [disabled]="pagination.current === 1"
            [ngClass]="{
              'cursor-not-allowed opacity-50 bg-gray-200 border-gray-300 text-gray-400':
                pagination.current === 1,
              'hover:bg-primary hover:border-primary hover:text-white':
                pagination.current !== 1
            }"
            class="px-3 py-1 flex items-center justify-center border rounded transition text-sm"
          >
            ‹
          </button>
          <ng-container *ngFor="let page of pagesToShow">
            <button
              *ngIf="page !== -1"
              (click)="goToPage(page)"
              [class.bg-primary]="pagination.current === page"
              [class.text-white]="pagination.current === page"
              class="px-3 py-1 border border-gray-400 text-gray-700 rounded hover:bg-primary hover:border-primary hover:text-white transition text-sm"
            >
              {{ page }}
            </button>
            <span *ngIf="page === -1" class="px-2">...</span>
          </ng-container>
          <button
            (click)="nextPage()"
            [disabled]="pagination.current === pagination.lastPage"
            [ngClass]="{
              'cursor-not-allowed opacity-50 bg-gray-200 border-gray-300 text-gray-400':
                pagination.current === pagination.lastPage,
              'hover:bg-primary hover:border-primary hover:text-white':
                pagination.current !== pagination.lastPage
            }"
            class="px-3 py-1 flex items-center justify-center border rounded transition text-sm"
          >
            ›
          </button>
        </div>
      </div>
      }
    </section>
    <section
      class="w-full md:w-2/3 bg-white rounded-sm pb-6 overflow-y-auto h-[calc(100vh-100px)] animate-pulse"
      *ngIf="isLoadingJobDetail"
    >
      <div class="relative w-full h-20 mb-4 bg-gray-300 rounded-sm"></div>
      <div class="flex flex-col lg:flex-row gap-6">
        <div class="w-full lg:w-4/5 flex flex-col gap-6 px-6">
          <div
            class="flex gap-4 items-center border-b border-gray-100 mt-8 pb-6"
          >
            <div class="w-14 h-14 rounded-sm bg-gray-300"></div>
            <div class="flex flex-col gap-2 w-full">
              <div class="w-40 h-4 bg-gray-300 rounded"></div>
              <div class="w-32 h-3 bg-gray-200 rounded"></div>
              <div class="flex gap-2 mt-2">
                <div class="w-24 h-5 bg-blue-100 rounded"></div>
                <div class="w-20 h-5 bg-green-100 rounded"></div>
              </div>
            </div>
          </div>
          <div>
            <div class="h-4 w-48 bg-gray-300 rounded mb-2"></div>
            <div class="h-3 w-full bg-gray-200 rounded mb-1"></div>
            <div class="h-3 w-5/6 bg-gray-200 rounded mb-1"></div>
            <div class="h-3 w-3/4 bg-gray-200 rounded"></div>
          </div>
          <div>
            <div class="h-4 w-48 bg-gray-300 rounded mb-2"></div>
            <div class="flex flex-col gap-1 ml-6">
              <div class="h-3 w-3/4 bg-gray-200 rounded"></div>
              <div class="h-3 w-4/5 bg-gray-200 rounded"></div>
              <div class="h-3 w-2/3 bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>
        <div
          class="w-full lg:w-2/5 p-4 flex flex-col justify-between border-l border-gray-100 min-h-[500px]"
        >
          <div class="flex flex-col gap-4">
            <div class="w-32 h-4 bg-gray-300 rounded"></div>
            <div class="flex flex-col gap-1">
              <div class="w-24 h-3 bg-gray-200 rounded"></div>
              <div class="w-32 h-3 bg-gray-200 rounded"></div>
            </div>
            <div class="flex flex-col gap-1">
              <div class="w-24 h-3 bg-gray-200 rounded"></div>
              <div class="w-32 h-3 bg-gray-200 rounded"></div>
            </div>
            <div class="flex flex-col gap-1">
              <div class="w-24 h-3 bg-gray-200 rounded"></div>
              <div class="w-32 h-3 bg-gray-200 rounded"></div>
            </div>
            <hr class="border-gray-100" />
            <div>
              <div class="w-48 h-4 bg-gray-300 rounded mb-2"></div>
              <div class="flex flex-wrap gap-2">
                <div class="w-16 h-5 bg-gray-200 rounded"></div>
                <div class="w-20 h-5 bg-gray-200 rounded"></div>
                <div class="w-14 h-5 bg-gray-200 rounded"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="w-full md:w-2/3 bg-white rounded-sm pb-6 overflow-y-auto h-[calc(100vh-100px)] flex items-center justify-center"
      *ngIf="!isLoadingJobDetail && !selectedJob"
    >
      <div class="flex flex-col items-center text-center px-6 py-12">
        <div
          class="w-16 h-16 flex items-center justify-center rounded-full bg-light text-primary mb-4 shadow"
        >
          <ng-icon name="bootstrapSuitcaseLg" size="30"></ng-icon>
        </div>
        <h2 class="text-xl font-semibold text-gray-700 mb-2">
          Selecciona una oferta de trabajo
        </h2>
        <p class="text-gray-500 max-w-md">
          Explora la lista de empleos disponibles en el panel izquierdo y
          selecciona el que más te interese para ver los detalles aquí.
        </p>
      </div>
    </section>
    <section
      class="w-full md:w-2/3 bg-white rounded-sm pb-6"
      *ngIf="!isLoadingJobDetail && selectedJob"
    >
      <div class="relative w-full h-20 sm:h-28 mb-4">
        <img
          [src]="companyBanner()"
          alt="Banner"
          class="w-full h-full object-cover"
        />
        <div class="absolute inset-0 opacity-50 bg-black"></div>
      </div>
      <div class="flex flex-col lg:flex-row gap-6">
        <div class="w-full lg:w-4/5 flex flex-col gap-6">
          <div
            class="flex flex-col sm:flex-row gap-4 items-start sm:items-center border-b border-gray-100 px-6 mt-2 pb-6"
          >
            <img
              [src]="companyImage()"
              alt="Logo"
              class="w-14 h-14 rounded-sm object-cover shadow"
            />
            <div class="flex flex-col w-full gap-3">
              <div
                class="flex flex-col sm:flex-row sm:items-center sm:justify-between w-full gap-2"
              >
                <div>
                  <h3 class="text-lg font-semibold line-clamp-2">
                    {{ selectedJob.title }}
                  </h3>
                  <p
                    class="text-sm text-gray-500 truncate max-w-[250px] sm:max-w-xs"
                  >
                    {{ selectedJob.company.commercialName }}
                  </p>
                </div>
              </div>
              <div class="flex flex-wrap gap-2 relative">
                <span
                  class="px-2 py-1 flex items-center gap-2 text-blue-800 bg-blue-100 rounded text-xs truncate max-w-[150px]"
                >
                  <ng-icon name="bootstrapSuitcaseLg" size="18"></ng-icon>
                  {{ selectedJob.type }}
                </span>
                <span
                  class="px-2 py-1 flex items-center gap-2 text-green-800 bg-green-100 rounded text-xs truncate max-w-[200px] relative group cursor-pointer"
                >
                  <ng-icon name="heroCheckBadge" size="18"></ng-icon>
                  {{ selectedJob.company.email }}
                  <span
                    class="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 px-3 py-1 rounded text-xs text-white bg-gray-800 opacity-0 group-hover:opacity-100 transition whitespace-nowrap z-50"
                  >
                    Compañía verificada por Codideep
                  </span>
                </span>
              </div>
              <div class="block lg:hidden mt-3">
                <ng-container
                  *ngIf="
                    selectedJob?.publicationStatus === 'Publicado';
                    else closedOfferMobile
                  "
                >
                  <button
                    [disabled]="isLoadingPostulant || postulantExists"
                    (click)="openModalPostulate()"
                    [ngClass]="{
                      'bg-primary text-white': !postulantExists,
                      'bg-gray-300 text-gray-600 cursor-not-allowed':
                        postulantExists
                    }"
                    class="w-full py-2 rounded flex items-center justify-center text-sm font-medium transition"
                  >
                    {{ postulantExists ? "Solicitado" : "Solicitar" }}
                  </button>
                </ng-container>
                <ng-template #closedOfferMobile>
                  <p class="italic text-gray-500 text-sm text-center mt-2">
                    Ya no se aceptan más postulaciones para esta oferta
                  </p>
                </ng-template>
              </div>
            </div>
          </div>
          <div class="px-6">
            <div
              [innerHTML]="selectedJob.description"
              class="custom-editor"
            ></div>
          </div>
        </div>
        <div
          class="hidden lg:flex w-full lg:w-2/5 rounded-md p-4 flex-col justify-between h-full min-h-[500px] border-l border-gray-100"
        >
          <div class="flex flex-col gap-4">
            <div class="mt-4 flex flex-col gap-2">
              <ng-container
                *ngIf="
                  selectedJob?.publicationStatus === 'Publicado';
                  else closedOffer
                "
              >
                <button
                  [disabled]="isLoadingPostulant || postulantExists"
                  (click)="openModalPostulate()"
                  [ngClass]="{
                    'bg-primary text-white': !postulantExists,
                    'bg-gray-300 text-gray-600 cursor-not-allowed':
                      postulantExists
                  }"
                  class="px-4 py-2 rounded flex items-center justify-center min-w-[120px] transition"
                >
                  {{ postulantExists ? "Solicitado" : "Solicitar" }}
                </button>
              </ng-container>
              <ng-template #closedOffer>
                <p class="italic text-gray-500 text-sm">
                  Ya no se aceptan más postulaciones para esta oferta
                </p>
              </ng-template>
            </div>
            <div>
              @if(selectedJob.showSalary == "1"){
              <h2 class="text-xl font-semibold">
                Pago: {{ selectedJob.salary || "0" | solesCurrency }}
              </h2>
              }
            </div>
            <div>
              <p class="text-sm text-black font-medium">Compañía</p>
              <p class="text-sm text-gray-800 line-clamp-2">
                {{ selectedJob.company.commercialName }}
              </p>
            </div>
            <div>
              <p class="text-sm text-black font-medium">Publicado</p>
              <p class="text-sm text-gray-800">
                {{ selectedJob.publicationDate | date }}
              </p>
            </div>
            <div>
              <p class="text-sm text-black font-medium">Ubicación</p>
              <p class="text-sm text-gray-800 line-clamp-2">
                {{ selectedJob.company.district }}
              </p>
            </div>
            <hr class="border-gray-100" />
          </div>
        </div>
      </div>
    </section>
  </main>
</div>
<div
  *ngIf="modalPostulant"
  class="fixed inset-0 bg-black/70 bg-opacity-60 flex items-center justify-center z-50"
>
  <div class="bg-white rounded-lg shadow-lg max-w-sm w-full p-6 text-center">
    <h2 class="text-lg font-semibold text-gray-800 mb-4">
      ¿Estás seguro que deseas postular a este empleo?
    </h2>
    <div class="flex justify-center gap-4">
      <button
        (click)="closeModalPostulate()"
        class="px-4 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
      >
        Cancelar
      </button>
      <app-loading-button
        (click)="postulate()"
        [text]="'Confirmar'"
        [loading]="isLoadingPostulant"
        type="button"
      >
      </app-loading-button>
    </div>
  </div>
</div>
